import bModal from '../modal/js/bModal'
import bOffcanvas from '../offcanvas/js/bOffcanvas'
import bToast from '../toast/js/bToast'

Object.assign(window, {
  bModal,
  bOffcanvas,
  bToast
})
